export default "__VITE_PUBLIC_ASSET__bdb7d41b__"